<mat-card>
  <app-card-header
    [title]="'Cumplimiento: ' + data.recorrido.nombre"
    [subtitle]="
      data.recorrido.ventana?.fechaDesde
        ? (data.recorrido.ventana?.fechaDesde | date: 'dd/MM/yyyy HH:mm') +
          ' → ' +
          (data.recorrido.ventana?.fechaHasta | date: 'dd/MM/yyyy HH:mm')
        : ''
    "
    icono="fact_check"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    @if (loading) {
      <app-loading
        text="Calculando cumplimiento..."
        [diameter]="50"
      ></app-loading>
    } @else if (detalle) {
      <div class="dcp-cabecera">
        <span
          class="dcp-estado"
          [class.dcp-ok]="detalle.cumplio"
          [class.dcp-fail]="!detalle.cumplio"
        >
          <mat-icon>{{ detalle.cumplio ? 'check_circle' : 'cancel' }}</mat-icon>
          {{ detalle.cumplio ? 'Cumplió' : 'No cumplió' }}
        </span>
      </div>

      <div class="dcp-tabla">
        <div class="dcp-fila dcp-encabezado">
          <span>#</span>
          <span>Punto</span>
          <span>Llegada</span>
          <span>Salida</span>
          <span>Tiempo</span>
        </div>
        @for (punto of detalle.puntos; track punto; let i = $index) {
          <div class="dcp-fila" [class.dcp-no-visitado]="!punto.visitado">
            <span>{{ i + 1 }}</span>
            <span class="dcp-punto">
              {{
                punto.direccion ??
                  (punto.coordenadas[1] | number: '1.5-5') +
                    ', ' +
                    (punto.coordenadas[0] | number: '1.5-5')
              }}
            </span>
            @if (punto.visitado) {
              <span>{{ punto.horaLlegada | date: 'HH:mm:ss' }}</span>
              <span>
                @if (punto.siguioEnZona) {
                  <span class="dcp-sigue">Sigue en la zona</span>
                } @else {
                  {{ punto.horaSalida | date: 'HH:mm:ss' }}
                }
              </span>
              <span>{{ formatSegundos(punto.permanenciaSegundos) }}</span>
            } @else {
              <span class="dcp-sin-visita">No visitado</span>
            }
          </div>
        }
      </div>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
      Cerrar
    </button>
  </mat-card-actions>
</mat-card>
